import React from "react";
import { CollaboratorListContainer } from "./__styles__/CollaboratorList";
import { CollaboratorRow } from "./CollaboratorRow";
import { Collaborator, PermissionOption } from "./types";

interface CollaboratorListProps {
  collaborators: Collaborator[];
  permissionOptions: PermissionOption[];
  onPermissionChange?: (collaboratorId: string, permission: string) => void;
  showRemoveOption?: boolean;
  onRemove?: (collaboratorId: string) => void;
  showRole?: boolean;
}

export const CollaboratorList = ({
  collaborators,
  permissionOptions,
  onPermissionChange,
  showRemoveOption = false,
  onRemove,
  showRole = false,
}: CollaboratorListProps) => {
  return (
    <CollaboratorListContainer>
      {collaborators.map(collaborator => (
        <CollaboratorRow
          key={collaborator.id}
          collaborator={collaborator}
          permissionOptions={permissionOptions}
          onPermissionChange={onPermissionChange}
          showRemoveOption={showRemoveOption}
          onRemove={onRemove}
          showRole={showRole}
        />
      ))}
    </CollaboratorListContainer>
  );
};
